// A map of AdyenCardBrand - zppCardBrand. Used to get the zpp card brand from a given Adyen brand.
const creditCardBrandOfAdyenBrand = {
    amex: 'american_express',
    cartebancaire: 'carte_bancaire',
    diners: 'diners_club',
    maestro: 'maestro',
    mc: 'master_card',
    visa: 'visa',
};
// A map of zppCardBrand - AdyenCardBrand. Used to get the Adyen card brand from a given zpp brand.
const adyenBrandOfCreditCardBrand = {
    american_express: 'amex',
    carte_bancaire: 'cartebancaire',
    diners_club: 'diners',
    maestro: 'maestro',
    master_card: 'mc',
    other: null,
    visa: 'visa',
};

export { adyenBrandOfCreditCardBrand, creditCardBrandOfAdyenBrand };
//# sourceMappingURL=AdyenTypes.js.map
